import { Grid} from "@material-ui/core";
import { SectionProps } from "./SectionProps";
import { Controller } from "react-hook-form";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { fieldLabels } from "./fieldLabels";
import { Error } from "../common/Error";
import { SarsModel } from "../../domain/SarsModel";
import { countryService } from "../../services";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import { Select } from "@ofqual/portal-components/components/Select";

export const CitizenDetails: React.FC<{
  sectionProps: SectionProps<SarsModel>;
}> = ({ sectionProps }) => {
  const { control, errors, disabled } = sectionProps;

  const [countriesLookup] = useLookup(countryService);


  return (
    // <div className={classes.inlineFields}>
    <Grid container spacing={3}>
      <Grid item xs={12} sm={4}>
        <Controller
          control={control}
          rules={{ required: true, maxLength: 255 }}
          name="firstName"
          as={
            <TextField
              label={fieldLabels.firstName}
              data-test="firstName-field"
              readOnly={disabled}
              required
              aria-label="First name"
            />
          }
        />
        {errors.firstName?.type === "required" && (
          <Error data-test="firstName-validation">This field is required</Error>
        )}
        {errors.firstName?.type === "maxLength" && (
          <Error data-test="firstName-length-validation">
            Max length exceeded
          </Error>
        )}
      </Grid>
      <Grid item xs={12} sm={4}>
        <Controller
          control={control}
          rules={{ maxLength: 255 }}
          name="middleName"
          as={
            <TextField
              label={fieldLabels.middleName}
              data-test="middleName-field"
              readOnly={disabled}
              aria-label="Middle name"
            />
          }
        />
        {errors.lastName?.type === "maxLength" && (
          <Error data-test="middleName-length-validation">
            Max length exceeded
          </Error>
        )}
      </Grid>

      <Grid item xs={12} sm={4}>
        <Controller
          control={control}
          rules={{ required: true, maxLength: 255 }}
          name="lastName"
          as={
            <TextField
              label={fieldLabels.lastName}
              data-test="lastName-field"
              readOnly={disabled}
              required
              aria-label="Last name"
            />
          }
        />
        {errors.lastName?.type === "required" && (
          <Error data-test="lastName-validation">This field is required</Error>
        )}
        {errors.lastName?.type === "maxLength" && (
          <Error data-test="lastName-length-validation">
            Max length exceeded
          </Error>
        )}
      </Grid>
      <Grid item xs={12} sm={4}>
        <Controller
          control={control}
          name="telephone"
          rules={{ maxLength: 15 }}
          as={
            <TextField
              label={fieldLabels.telephone}
              data-test="telephone-field"
              readOnly={disabled}
              aria-label="Tel number input"
            />
          }
        />
        {errors.telephone?.type === "maxLength" && (
          <Error data-test="telephone-length-validation">
            Max length exceeded
          </Error>
        )}
      </Grid>
      <Grid item xs={12} sm={12}>
        <Controller
          control={control}
          rules={{
            maxLength: 255,
            pattern: {
              value: /\S+@\S+\.\S+/,
              message: "Entered value does not match an email format",
            },
          }}
          name="email"
          as={
            <TextField
              label={fieldLabels.email}
              data-test="email-field"
              readOnly={disabled}
              type="email"
              aria-label="Email input"
            />
          }
        />
        {errors.email?.type === "maxLength" && (
          <Error data-test="email-validation">Max length exceeded</Error>
        )}
        {errors.email?.type === "pattern" && (
          <Error data-test="email-validation">{errors.email.message}</Error>
        )}
      </Grid>
      <Grid item xs={12} sm={12}>
        <Controller
          control={control}
          rules={{ maxLength: 255 }}
          name="line1"
          as={
            <TextField
              data-test="address-line1"
              variant="outlined"
              label={fieldLabels.line1}
              fullWidth
              readOnly={disabled}
            />
          }
        />
        {errors.line1?.type === "maxLength" && (
          <Error data-test="line1-validation">Max length exceeded</Error>
        )}
      </Grid>
      <Grid item xs={12} sm={12}>
        <Controller
          control={control}
          rules={{ maxLength: 255 }}
          name="line2"
          as={
            <TextField
              data-test="address-line2"
              variant="outlined"
              label={fieldLabels["line2"]}
              fullWidth
              readOnly={disabled}
            />
          }
        />
        {errors.line2?.type === "maxLength" && (
          <Error data-test="line2-validation">Max length exceeded</Error>
        )}
      </Grid>
      <Grid item xs={12} sm={12}>
        <Controller
          control={control}
          rules={{ maxLength: 255 }}
          name="line3"
          as={
            <TextField
              data-test="address-line3"
              variant="outlined"
              label={fieldLabels["line3"]}
              fullWidth
              readOnly={disabled}
            />
          }
        />
        {errors.line3?.type === "maxLength" && (
          <Error data-test="line3-validation">Max length exceeded</Error>
        )}
      </Grid>
      <Grid item xs={12} sm={12}>
        <Controller
          control={control}
          rules={{ maxLength: 255 }}
          name="line4"
          as={
            <TextField
              data-test="address-line4"
              variant="outlined"
              label={fieldLabels["line4"]}
              fullWidth
              readOnly={disabled}
            />
          }
        />
        {errors.line4?.type === "maxLength" && (
          <Error data-test="line4-validation">Max length exceeded</Error>
        )}
      </Grid>
      <Grid item xs={12} sm={12}>
        <Controller
          control={control}
          rules={{ maxLength: 255 }}
          name="postcode"
          as={
            <TextField
              data-test="address-postcode"
              variant="outlined"
              label={fieldLabels.postCode}
              fullWidth
              readOnly={disabled}
            />
          }
        />
        {errors.postcode?.type === "maxLength" && (
          <Error data-test="postcode-validation">Max length exceeded</Error>
        )}
      </Grid>
      <Grid item xs={12} sm={12}>
        <Controller
          control={control}
          name="countryId"
          as={
            <Select
              label={fieldLabels.country}
              datatest="address-country"
              readOnly={disabled}
              fullWidth
            >
              {countriesLookup}
            </Select>
          }
        />
      </Grid>
    </Grid>
    // </div>
  );
};
